const items = [
  {
    id: 'media-1',
    title: '深度起底：网红虚假人设的完整产业链',
    desc: '从剧本策划到水军控评，一套价值千万的网红人设制造流水线被完整揭露。',
    duration: '15:32',
    views: '86.7万次播放',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20video%20thumbnail%20style%20with%20dramatic%20warm%20crimson%20lighting%2C%20play%20button%20overlay%2C%20investigative%20journalism%20theme%2C%20dark%20moody%20background%20with%20amber%20accents%2C%20professional%20editorial%20style%2C%20intense%20atmosphere%2C%20widescreen%20format&width=800&height=450&seq=media-card-1&orientation=landscape',
  },
  {
    id: 'media-2',
    title: '独家采访：前MCN运营总监自曝行业内幕',
    desc: '从业五年的MCN高管首次公开讲述签约套路、流量造假与KPI压榨的真实故事。',
    duration: '22:08',
    views: '73.4万次播放',
    img: 'https://readdy.ai/api/search-image?query=Interview%20scene%20thumbnail%20with%20warm%20dramatic%20lighting%2C%20silhouette%20subject%20against%20dark%20background%2C%20play%20icon%20overlay%2C%20professional%20documentary%20style%2C%20golden%20and%20amber%20tones%2C%20cinematic%20composition%2C%20intense%20mood&width=800&height=450&seq=media-card-2&orientation=landscape',
  },
  {
    id: 'media-3',
    title: '年度复盘：十大网红翻车事件完整还原',
    desc: '按时间线梳理全年最具影响力的网红翻车事件，附带当事人回应与后续发展。',
    duration: '18:45',
    views: '91.2万次播放',
    img: 'https://readdy.ai/api/search-image?query=Year%20in%20review%20compilation%20thumbnail%20style%20with%20warm%20crimson%20and%20golden%20highlights%2C%20montage%20of%20news%20headlines%2C%20dramatic%20cinematic%20lighting%2C%20play%20button%20overlay%2C%20professional%20editorial%20style%2C%20dark%20moody%20background&width=800&height=450&seq=media-card-3&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">视频爆料</h2>
          <span className="text-xs text-foreground-500 bg-secondary-100 px-2 py-0.5 rounded-full">精选视频</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {items.map((item) => (
            <a
              key={item.id}
              href={`#cards`}
              className="group block bg-background-50 rounded-lg border border-secondary-200/60 hover:border-primary-300 overflow-hidden transition-all cursor-pointer"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden bg-secondary-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) target.parentElement.classList.add('hidden');
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-600 transition-colors">
                    <i className="ri-play-fill text-background-50 text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 bg-background-950/70 text-background-50 text-xs px-2 py-0.5 rounded whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-bold text-foreground-950 group-hover:text-primary-600 transition-colors mb-1 leading-snug">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed mb-2">{item.desc}</p>
                <span className="text-xs text-foreground-500">{item.views}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}